var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headers[_vm.section])?_c('span',{staticClass:"brief-explanation",domProps:{"innerHTML":_vm._s(_vm.headers[_vm.section])}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }